import React, { Component } from "react";
import ContentWrapper from "../../../components/common/ContentWrapper.js";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import "../../../components/admin/css/common.css";
import { history } from "../../../helper/history.js";
import { TreeMainService } from "../../../service/manage/h_tree/tree_main.service.js";
import Spinner from "react-bootstrap/Spinner";
import config from "../../../helper/config.js";
import { customerConstants } from "../../../helper/constants.js";
import ManageFormSetup from "./ManageFormSetup.js";
import SimpleReactValidator from "simple-react-validator";
import ManageFormView from "./ManageFormView.js";
import { Tooltip } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { compoenentRenderFrom } from "../../../helper/namespace.js";
import { routes } from "../../../helper/routes.js";
import Button from "react-bootstrap/Button";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

let tabTextColor;
const customer = getCustomerFeatureFlag();
switch (customer) {
  case customerConstants.EXO_CUSTOMER1:
    tabTextColor = "var(--maincolor)";
    break;
  case customerConstants.EXO_CUSTOMER2:
    tabTextColor = "var(--maincolor-cmc)";
    break;
  default:
    tabTextColor = "var(--maincolor)";
    break;
}

const privileges = {
  tabVisibility: false,
  addVisibility: false,
  editVisibility: false,
  deleteVibility: false,
  viewVisibility: false,
  isAdmin: false,
  isStudent: false,
  isTeacher: false,
};

export default class MainManageEvaluateB extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
      showInsertModal: false,
      showModal: false,
      isLoading: false,
      isTableDataLoading: true,
      isModified: false,
      selectedStudentId: "",
      selectedStudentTable: "",
      selectedStudent: null,
      search_id: "",
      isStudentsLoading: false,
      isSubmitting: false,
      registration_id: "",
      editVisibility: false,
      addVisibility: false,
      breadcrumb2: null,
      nodeTitle: null,
      flg_list_active: null,
      selectedStudent: null,
      selectedPackage: null,
      userType: "",
      formSetupPrivilage: privileges,
      formViewPrivilage: privileges,
      //   manageReportTitlePrivilage: privileges,
      //   manageReportSubjectPrivilage: privileges,
      privilageLoading: true,
    };
  }

  handleTabChange = (event, newValue) => {
    this.setState({ activeTab: newValue });
  };

  componentDidMount() {
    const {
      privilege_add,
      privilege_edit,
      breadcrumb2,
      nodeTitle,
      flg_list_active,
      privilege_view,
      privilege_delete,
      lg_user_id,
      lg_user_table_id,
    } = this.props.state;

    const userType = sessionStorage.getItem("userType");

    TreeMainService.getUserType(lg_user_table_id).then((response) => {
      this.setState(
        {
          breadcrumb2: breadcrumb2,
          nodeTitle,
          flg_list_active,
          userType: userType,
        },
        () => {
          this.getVisibilityCheck(privilege_add, privilege_edit);
          this.setRoleBasedPrivilege(
            privilege_add,
            privilege_edit,
            privilege_view,
            privilege_delete
          );
        }
      );
    });
  }

  getVisibilityCheck(privilege_add, privilege_edit) {
    if (privilege_add == "1") {
      this.setState({
        addVisibility: true,
      });
    }
    if (privilege_edit == "1") {
      this.setState({
        editVisibility: true,
      });
    }
  }

  setRoleBasedPrivilege(
    privilege_add,
    privilege_edit,
    privilege_view,
    privilege_delete
  ) {
    const { userType } = this.state;

    const formViewPrivilege = {
      tabVisibility: privilege_view || privilege_add,
      addVisibility: privilege_add,
      editVisibility: privilege_edit,
      deleteVisibility: privilege_delete,
      viewVisibility: privilege_view,
      showManageFormSetup: privilege_edit || privilege_delete,
    };

    // Determine which tabs should be visible
    const tabList = [];
    let defaultTab = 0; // Default to the first tab

    if (formViewPrivilege.tabVisibility) {
      if (formViewPrivilege.showManageFormSetup) {
        tabList.push({ label: "Form Setup", value: 0 });
        if (defaultTab === 0) {
          defaultTab = 0;
        }
      }
      if (formViewPrivilege.viewVisibility) {
        tabList.push({ label: "Check list Form", value: 1 });
        if (defaultTab === 0) {
          defaultTab = 1;
        }
      }
    }

    // Update state with the tabList and the defaultTab
    this.setState({
      formViewPrivilege,
      privilageLoading: false,
      tabList,
      activeTab: tabList.length > 0 ? defaultTab : 0,
    });
  }

  handleStudentProfileRoute = (student) => {
    const { history, state } = this.props;
    let route = routes.student_profile;

    if (customer === customerConstants.EDF_CUSTOMER4) {
      route = routes.reg_b_student_profile;
    }

    history.push({
      pathname: route,
      state: {
        ...state?.adminState,
        student,
      },
    });
  };

  render() {
    const path = history.location.pathname;

    const {
      formViewPrivilege,
      privilageLoading,
      tabList,
      activeTab,
      userType,
    } = this.state;
    const privilegeSetup = (
      <div
        className="Ttip"
        style={{ fontFamily: "Arial, sans-serif", lineHeight: "1.6" }}
      >
        <div className="Ttip" style={{ textAlign: "justify", padding: "10px" }}>
          <p>
            An Admin with full privileges (default privilege group: V+A+E+D) can
            set up, update, and save the checklist form. To assign different
            admin roles (e.g., course coordinators) with specific permissions
            like "update & save" or "view only," they must be removed from the
            common Admin group and added as new user groups with the appropriate
            privileges, as outlined below.
          </p>
        </div>

        <h4>Scenario 1: Admin Editing the Checklist, Student Can View Only</h4>
        <p>
          <strong>Admin</strong>
        </p>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            Privileges: <strong>View (V), Edit (E)</strong>
          </li>
          <li>
            Record Restrictions: <strong>Admin: No restriction</strong>
          </li>
          <li>
            Dropdown Restrictions: <strong>Admin: No restriction</strong>
          </li>
        </ul>

        <p>
          <strong>Student</strong>
        </p>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            Privileges: <strong>View (V) only</strong>
          </li>
          <li>
            Record Restrictions: <strong>Student: Record Creator</strong>
          </li>
          <li>
            Dropdown Restrictions: <strong>Student: No restriction</strong>
          </li>
        </ul>

        <h4>Scenario 2: Student Editing the Checklist, Admin Can View Only</h4>
        <p>
          <strong>Admin</strong>
        </p>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            Privileges: <strong>View (V)</strong>
          </li>
          <li>
            Record Restrictions: <strong>Admin: No restriction</strong>
          </li>
          <li>
            Dropdown Restrictions: <strong>Admin: No restriction</strong>
          </li>
        </ul>

        <p>
          <strong>Student</strong>
        </p>
        <ul style={{ paddingLeft: "20px" }}>
          <li>
            Privileges: <strong>View (V), Add (A)</strong>
          </li>
          <li>
            Record Restrictions: <strong>Student: Record Creator</strong>
          </li>
          <li>
            Dropdown Restrictions: <strong>Student: No restriction</strong>
          </li>
        </ul>
      </div>
    );

    return (
      <div style={{ height: "90vh", overflow: "auto" }}>
        <ContentWrapper disabled={path === "/manage-search"}>
          <div className="row justify-content-end">
            <div>
              {this.props.state.path ===
                compoenentRenderFrom.STUDENT_PROFILES && (
                <Button
                  onClick={() =>
                    this.handleStudentProfileRoute(
                      this.props.state.adminState?.student
                    )
                  }
                >
                  Back
                </Button>
              )}
            </div>
          </div>
          {!formViewPrivilege ? (
            <div className="loading-container">
              <Spinner animation="border" role="status">
                <span className="sr-only">Loading...</span>
              </Spinner>
            </div>
          ) : (
            <div>
              {tabList.length > 0 && (
                <Tabs
                  value={activeTab}
                  onChange={this.handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  sx={{
                    "& .MuiTab-root": {
                      fontFamily: "Poppins, sans-serif",
                      textTransform: "unset",
                      letterSpacing: "-0.4px",
                      fontWeight: "600",
                    },
                    "& .Mui-selected": {
                      color: tabTextColor + " !important",
                    },
                    borderRight: 1,
                    borderColor: "divider",
                    backgroundColor: "#fff",
                  }}
                  TabIndicatorProps={{
                    style: {
                      backgroundColor: tabTextColor,
                    },
                  }}
                >
                  {tabList.map((tab) => (
                    <Tab key={tab.value} label={tab.label} value={tab.value} />
                  ))}
                  {userType === "admin" && (
                    <Tooltip title={privilegeSetup} placement="right-end" arrow>
                      <HelpIcon
                        style={{ cursor: "pointer", marginTop: "10px" }}
                      />
                    </Tooltip>
                  )}
                </Tabs>
              )}

              {!privilageLoading &&
                activeTab === 0 &&
                formViewPrivilege.showManageFormSetup && (
                  <ManageFormSetup
                    props={this.props.state}
                    formSetupPrivilage={formViewPrivilege}
                  ></ManageFormSetup>
                )}
              {!privilageLoading &&
                activeTab === 1 &&
                formViewPrivilege.tabVisibility && (
                  <ManageFormView
                    props={this.props.state}
                    formViewPrivilage={formViewPrivilege}
                  ></ManageFormView>
                )}
            </div>
          )}
        </ContentWrapper>
      </div>
    );
  }
}
